module.exports = __webpack_public_path__ + "media/application/images/icons/back-arrow-3375bbbd559337a731a86ce28e674641.svg";